// extracted by mini-css-extract-plugin
export default {"app_fade":"app-suspense_app_fade__WNHAc","entered":"app-suspense_entered__L6J5y"};